import React from "react";
import "./AddImage.css";
import dots from "../../images/dots.svg";
import drageAudio from "../../assets/images/model/drageAudio.svg";

const AddAudio = ({ draggable, onDragStart, setDraggedType }) => {
  return (
    <div
      className="parentContainer_image"
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={() => {
        setDraggedType("");
      }}
    >
      <div className="outer-container_image">
        <div className="drag-handle top-0 h-100">
          <div className="icon_tamplet">
            <img src={dots} className="img-fluid" alt="dots" />
          </div>
        </div>
        <div className="section-header-container">
          <div className="section-header">
            <span className="section-title">add a audio</span>
            <div className="icon_change">
              <img style={{ paddingLeft: "5px" }} src={drageAudio} alt="" />
            </div>
            <span className="drag_hover ">
              drag to the book to add textbook block
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAudio;
